import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { WhoIsForOptionsDTO } from '../../../api/useAutomatedAccountsQuery';
import { VisualPickerButton } from '../../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButton';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { WorkflowCurrentStepFC } from '../../../AutoAccountWorkflow.types';
import { StepCard } from '../../StepCard/StepCard';
import { CustomerType } from '../../../../../ApexOPL/AccountOpening/AccountOpening.meta';

export const WHO_IS_FOR = 'whoIsFor';

export interface WhoIsFormField {
  [WHO_IS_FOR]?: WhoIsForOptionsDTO | null;
}

export const WhoIsThisAccountFor: WorkflowCurrentStepFC = ({ onNext, data }) => {
  const { setValue } = useFormContext<WhoIsFormField>();

  return (
    <StepCard>
      <Text color="neutral.700" fontSize="h3" fontWeight={500}>
        Who is this account for?
      </Text>

      <Box display="flex" flexDirection="column">
        {data.allowedConsumerTypes.includes(CustomerType.Individual) && (
          <VisualPickerButton
            onClick={() => {
              setValue(WHO_IS_FOR, WhoIsForOptionsDTO.Single);
              onNext();
            }}
            mt="32"
          >
            Single
          </VisualPickerButton>
        )}

        {data.allowedConsumerTypes.includes(CustomerType.Joint) && (
          <VisualPickerButton
            onClick={() => {
              setValue(WHO_IS_FOR, WhoIsForOptionsDTO.Joint);
              onNext();
            }}
            mt="16"
          >
            Joint
          </VisualPickerButton>
        )}
      </Box>
    </StepCard>
  );
};
